export default function Logo() {
  return (
    <span className="flex items-center" data-testid="logo">
      <img
        src="/teknik-logo-white.png"
        alt="Teknik Enterprises"
        className="h-9 w-auto sm:h-10"
      />
    </span>
  );
}
